import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import DataRepositoryHelper from './data-repository-helper';
import SystemTypes from '../helpers/system-types';

var instance = null;

var addIfNotEmpty = DataRepositoryHelper.addIfNotEmpty;
var createSystemTrendDictionary = DataRepositoryHelper.createSystemTrendDictionary;
var extractCallControlData = DataRepositoryHelper.extractCallControlData;
var extractCallData = DataRepositoryHelper.extractCallData;
var extractSystemStatuses = DataRepositoryHelper.extractSystemStatuses;
var extractVMRData = DataRepositoryHelper.extractVMRData;
var getSystemIdsAndNames = DataRepositoryHelper.getSystemIdsAndNames;
var getSystemNames = DataRepositoryHelper.getSystemNames;
var mapSystemDetails = DataRepositoryHelper.setSystemDetailParticipantData;
var pushToMaxObservable = DataRepositoryHelper.pushToMaxObservable;
var shiftSystemTrendDataValues = DataRepositoryHelper.shiftSystemTrendDataValues;

function DataRepository() {
    var self = this;
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one DataRepository. Call DataRepository.getInstance() instead.');
    }

    self._hasBridges = null;
    self._hasCallControlDevices = null;
    self._hasEndpoints = null;
    self.lastPanelId = null;
    self.lastParams = null;
    self.lastParamsDictionary = {};
    self.lastQueryTimeDictionary = {};
    initializeObservableProperties(self);

    self.getDictionaryValue = function (observableDictionary, params) {
        var key = ko.toJSON(params);
        var dictionary = observableDictionary();
        var queryId = params.queryId;
        var result;

        if (!queryId) {
            result = dictionary[key];

        } else if ((key === self.lastParamsDictionary[queryId]) && dateIsNotStale(queryId)) {
            result = dictionary[queryId];

        } else {
            result = null;
        }

        return result;
    };

    self.getErrorValue = function (params) {
        var key = ko.toJSON(params);
        return self.errorDictionary()[key];
    };

    self.setDictionaryValue = function (observableDictionary, method, params, value, errMsg) {
        var key = ko.toJSON(params);
        var queryId = params.queryId;
        var errvals = self.errorDictionary();

        if (errMsg) {
            errvals[key] = errMsg;
            self.errorDictionary(errvals);

        } else {
            errvals[key] = null;
            self.errorDictionary(errvals);
        }

        var dictvals = observableDictionary();

        if (!queryId) {
            dictvals[key] = value;

        } else {
            self.lastParamsDictionary[queryId] = key;
            dictvals[queryId] = value;
            self.lastQueryTimeDictionary[queryId] = new Date();
        }

        self.lastParams = key;
        self.lastPanelId = params.panelId;

        observableDictionary(dictvals);
    };

    function dateIsNotStale(queryId) {
        var dt = self.lastQueryTimeDictionary[queryId];
        if (!dt) {
            return true;
        }
        var now = new Date();
        var difference = now.getTime() - dt.getTime();
        var resultInMinutes = Math.round(difference / 60000);
        return (resultInMinutes <= 60);
    }

    function initializeObservableProperties(self) {
        self.alertsData = ko.observableArray();
        self.dictionaryOfNonBridgesNonCallControlsWithIdsObservable = ko.observable({});
        self.dictionaryOfBridgesWithIdsObservable = ko.observable({});
        self.dictionaryOfCallControlsWithIdsObservable = ko.observable({});
        self.dictionaryOfSystemsObservable = ko.observable({});
        self.endpointCallData = ko.observable({});
        self.endpointHistoricalInfo = ko.observable({});
        self.endpointHwStatusSummary = ko.observable({});
        self.endpointModels = ko.observableArray();
        self.endpointStatusData = ko.observableArray();
        self.errorDictionary = ko.observable({});
        self.FactFilterDictionary = ko.observable({});
        self.flexQueryMetaData = ko.observable({});
        self.FlexQueryResultDictionary = ko.observable({});
        self.historicalMetadataXml = ko.observable({});
        self.listOfEndpointsObservable = ko.observableArray();
        self.listOfEndpointsWithIdsObservable = ko.observableArray();
        self.listOfPexipLocationsObservable = ko.observableArray();
        self.logiReportParamsObservableDictionary = ko.observable({});
        self.orgPreferences = ko.observable({});
        self.integrations = ko.observable({});
        self.exportRegistrations = ko.observableArray();
        self.overallQualityTotals = ko.observable({});
        self.QueryResultDatasetDictionary = ko.observable({});
        self.QueryResultDictionary = ko.observable({});
        self.rooms = ko.observableArray();
        self.summaryData = ko.observableArray();
        self.systemDetailData = ko.observableArray();
        self.systemDetailDataAllBridges = ko.observableArray();
        self.systemDetailDataCallControls = ko.observableArray();
        self.systemDetailParticipantData = ko.observable({});
        self.systemsDictionary = ko.observable({});
        self.systemStatusData = ko.observableArray();
        self.systemStatusDataAcano = ko.observableArray();
        self.systemStatusDataAllBridges = ko.observableArray();
        self.systemStatusDataBlueJeans = ko.observableArray();
        self.systemStatusDataCTPSCondMgd = ko.observableArray();
        self.systemStatusDataCTPSStandalone = ko.observableArray();
        self.systemStatusDataCUCM = ko.observableArray();
        self.systemStatusDataDMA = ko.observableArray();
        self.systemStatusDataMCU = ko.observableArray();
        self.systemStatusDataPexip = ko.observableArray();
        self.systemStatusDataPexipLocations = ko.observable({});
        self.systemStatusDataRMX = ko.observableArray();
        self.systemStatusDataSKYPE = ko.observableArray();
        self.systemStatusDataCallControls = ko.observableArray();
        self.systemStatusDataVCSOnly = ko.observableArray();
        self.systemStatusDataVCSX = ko.observableArray();
        self.systemStatusDataZOOM = ko.observableArray();
        self.systemStatusDataRPAD = ko.observableArray();
        self.systemStatusDataRPRM = ko.observableArray();
        self.systemTrendDataIncremental = ko.observableArray();
        self.systemTrendDataInitial = ko.observableArray();
        self.systemTrendDictionary = ko.observable({});
        self.tmsScheduleData = ko.observableArray();
        self.usersList = ko.observableArray();
        self.xmlMetadata = ko.observable({});
    }
}

DataRepository.prototype.beforeInvokingService = function (method, params) {
    var self = this;

    if (params.queryId === 'FlexAccessQuery') {
        updateParamsUrlIfEmpty(params);
        return true;
    }

    if (method === 'GetQueryResultJson') {
        updateParamsUrlIfEmpty(params);

        if (params.queryId === 'GetEndpointHistoricalInfo') {
            self.endpointHistoricalInfo(null);

        } else if (params.queryId === 'HistoricalMetadataXml') {
            self.historicalMetadataXml(null);

        } else if (params.queryId.indexOf('MetadataXml') >= 0) {
            self.xmlMetadata(null);

        } else {
            self.setDictionaryValue(self.QueryResultDictionary, method, params, null);
        }

    } else if (method === 'GetQueryResultDatasetJson') {
        updateParamsUrlIfEmpty(params);
        self.setDictionaryValue(self.QueryResultDatasetDictionary, method, params, null);

    } else if ((method === 'GetFlexQueryResultJson') || (method === 'GetKPIQueryResultDatasetJson')) {
        updateParamsUrlIfEmpty(params);
    }

    return true;

    function updateParamsUrlIfEmpty(params) {
        if (!params.url) {
            params.url = $(location).attr('href');
        }
    }
};

DataRepository.prototype.dispose = function () {
    var self = this;

    self._hasBridges = null;
    self._hasCallControlDevices = null;
    self._hasEndpoints = null;
    self.dictionaryOfNonBridgesNonCallControlsWithIdsObservable({});
    self.dictionaryOfBridgesWithIdsObservable({});
    self.dictionaryOfCallControlsWithIdsObservable({});
    self.dictionaryOfSystemsObservable({});
    self.endpointCallData({});
    self.endpointStatusData([]);
    self.FactFilterDictionary({});
    self.listOfEndpointsObservable([]);
    self.listOfEndpointsWithIdsObservable();
    self.logiReportParamsObservableDictionary({});
    self.overallQualityTotals({});
    self.QueryResultDatasetDictionary({});
    self.QueryResultDictionary({});
    self.rooms();
    self.summaryData([]);
    self.systemDetailData([]);
    self.systemDetailDataAllBridges([]);
    self.systemDetailDataCallControls([]);
    self.systemDetailParticipantData({});
    self.systemsDictionary({});
    self.systemStatusData([]);
    self.systemStatusDataAcano([]);
    self.systemStatusDataAllBridges([]);
    self.systemStatusDataBlueJeans([]);
    self.systemStatusDataCTPSCondMgd([]);
    self.systemStatusDataCTPSStandalone([]);
    self.systemStatusDataCUCM([]);
    self.systemStatusDataDMA([]);
    self.systemStatusDataMCU([]);
    self.systemStatusDataPexip([]);
    self.systemStatusDataPexipLocations({});
    self.systemStatusDataRMX([]);
    self.systemStatusDataSKYPE([]);
    self.systemStatusDataCallControls([]);
    self.systemStatusDataVCSOnly([]);
    self.systemStatusDataVCSX([]);
    self.systemStatusDataZOOM([]);
    self.systemTrendDataIncremental([]);
    self.systemTrendDataInitial([]);
    self.systemTrendDictionary({});

    instance = null;
};

DataRepository.prototype.getActiveCallsMetadata = function () {
    return {
        categoryOptions: SystemTypes.getRealtimeCallControlTypesExtended(),
        searchgrid: {
            headers: ['Source', 'Target', 'Start Time', 'Duration', 'System Name', 'System Type', 'Call Rate', 'Media Routed', 'Presentation', 'Quality', '' /*empty header for quality column*/],
            numericKeys: ['bitrate'],
            rowProperties: ['sourceAlias', 'destinationAlias', 'startTime', 'duration', 'systemname', 'systemtype', 'bitrate', 'hasQualityData', 'presentation', 'qualityIndicator', 'details'],
            sortableProperties: ['sourceAlias', 'destinationAlias', 'startTime', 'duration', 'systemname', 'systemtype', 'bitrate', 'hasQualityData', 'presentation', 'qualityIndicator']
        },
        typeaheadConditions: [
            { title: 'Source', name: 'sourceAlias', type: 'string' },
            { title: 'Target', name: 'destinationAlias', type: 'string' },
            { title: 'Call Rate', name: 'bitrate', type: 'numeric' },
            { title: 'Quality', name: '_quality', type: 'string' }
        ]
    };
};

DataRepository.prototype.getActiveVMRMetadata = function () {
    return {
        searchgrid: {
            headers: ['Meeting Name', 'Start Time', 'Duration', 'Participants', 'System Type', 'System Name', 'Host', 'Presentation', 'Quality'],
            rowProperties: ['name', 'startTime', 'duration', 'numOfParticipants', 'systemtype', 'systemname', 'systemhost', 'presentation', 'qualityIndicator']
        },
        innerTable: {
            headers: ['Participant Name', 'Participant Alias', 'Start Time', 'Duration', 'Call Type', 'Call Rate', 'Presentation', 'Packet Loss (%)', 'Jitter (ms)', 'Quality'],
            displayCols: ['name', 'remoteaddr', 'starttime', 'duration', 'calltype', 'bitrate', 'presentation', 'packetloss', 'jitter', 'details'],
            sortableProperties: ['name', 'remoteaddr', 'starttime', 'duration', 'calltype', 'bitrate', 'presentation', '_packetlossSort', '_jitterSort', 'details'],
            numericKeys: ['_packetlossSort', '_jitterSort']
        },
        typeaheadConditions: [
            { title: 'Meeting name', name: 'name', type: 'string' },
            { title: 'Quality', name: '_quality', type: 'string' },
            { title: 'Number of Participants', name: 'numOfParticipants', type: 'numeric' },
            { title: 'Host', name: 'systemhost', type: 'string' }
        ]
    };
};

DataRepository.prototype.getAlertsMetadata = function () {
    return {
        searchgrid: {
            headers: ['Name', 'Recipients', 'Category', 'Condition', 'Created By', 'Created On', 'Status'],
            rowProperties: ['name', 'recipients', 'category', 'condition', 'createdBy', 'createdDate', 'status', 'edit', 'remove'],
            sortableProperties: ['name', 'recipients', 'category', 'condition', 'createdBy', 'createdDate', 'status'],
            dateTimeKeys: ['createdDate'],
            widths: ['15%', '15%', '10%', '20%', '10%', '10%', '10%', '10%', '10%', '10%']
        },
        typeaheadConditions: [
            { title: 'Name', name: 'name', type: 'string' },
            { title: 'Recipients', name: 'recipients', type: 'string' },
            { title: 'Category', name: 'type', type: 'string' },
            { title: 'Condition', name: '_condition', type: 'string' },
            { title: 'Created By', name: 'createdByName', type: 'string' },
            { title: 'Status', name: 'status', type: 'string' }
        ]
    };
};

// TODO: This is a special case. RPRM is neither Call Control nor Bridge.
DataRepository.prototype.getDictionaryOfNonBridgesNonCallControlsWithIds = function() {
    var self = this;
    var result = {};

    addIfNotEmpty(result, 'RPRM', getSystemIdsAndNames(self.systemStatusDataRPRM()));

    return result;
};

DataRepository.prototype.getDictionaryOfBridgesWithIds = function () {
    var self = this;
    var result = {};

    addIfNotEmpty(result, 'ACANO', getSystemIdsAndNames(self.systemStatusDataAcano()));
    addIfNotEmpty(result, 'CMS', getSystemIdsAndNames(self.systemStatusDataAcano()));
    addIfNotEmpty(result, 'BJN', getSystemIdsAndNames(self.systemStatusDataBlueJeans()));
    addIfNotEmpty(result, 'CTPS - Conductor Managed', getSystemIdsAndNames(self.systemStatusDataCTPSCondMgd()));
    addIfNotEmpty(result, 'CTPS - Standalone', getSystemIdsAndNames(self.systemStatusDataCTPSStandalone()));
    addIfNotEmpty(result, 'MCU', getSystemIdsAndNames(self.systemStatusDataMCU()));
    addIfNotEmpty(result, 'PEXIP', getSystemIdsAndNames(self.systemStatusDataPexip()));
    addIfNotEmpty(result, 'RMX', getSystemIdsAndNames(self.systemStatusDataRMX()));
    addIfNotEmpty(result, 'SKYPE', getSystemIdsAndNames(self.systemStatusDataSKYPE()));
    addIfNotEmpty(result, 'ZOOM', getSystemIdsAndNames(self.systemStatusDataZOOM()));

    return result;
};

DataRepository.prototype.getDictionaryOfCallControlsWithIds = function () {
    var self = this;
    var result = {};

    addIfNotEmpty(result, 'CUCM', getSystemIdsAndNames(self.systemStatusDataCUCM()));
    addIfNotEmpty(result, 'DMA', getSystemIdsAndNames(self.systemStatusDataDMA()));
    addIfNotEmpty(result, 'RPAD', getSystemIdsAndNames(self.systemStatusDataRPAD()));
    addIfNotEmpty(result, 'SKYPE', getSystemIdsAndNames(self.systemStatusDataSKYPE()));
    addIfNotEmpty(result, 'VCS Control', getSystemIdsAndNames(self.systemStatusDataVCSOnly()));
    addIfNotEmpty(result, 'VCS Expressway', getSystemIdsAndNames(self.systemStatusDataVCSX()));

    return result;
};

DataRepository.prototype.getDictionaryOfSystems = function () {
    var self = this;
    var result = {};

    addIfNotEmpty(result, 'ACANO', getSystemNames(self.systemStatusDataAcano()));
    addIfNotEmpty(result, 'CMS', getSystemNames(self.systemStatusDataAcano()));
    addIfNotEmpty(result, 'BJN', getSystemNames(self.systemStatusDataBlueJeans()));
    addIfNotEmpty(result, 'CTPS - Conductor Managed', getSystemNames(self.systemStatusDataCTPSCondMgd()));
    addIfNotEmpty(result, 'CTPS - Standalone', getSystemNames(self.systemStatusDataCTPSStandalone()));
    addIfNotEmpty(result, 'CUCM', getSystemNames(self.systemStatusDataCUCM()));
    addIfNotEmpty(result, 'DMA', getSystemNames(self.systemStatusDataDMA()));
    addIfNotEmpty(result, 'MCU', getSystemNames(self.systemStatusDataMCU()));
    addIfNotEmpty(result, 'PEXIP', getSystemNames(self.systemStatusDataPexip()));
    addIfNotEmpty(result, 'RMX', getSystemNames(self.systemStatusDataRMX()));
    addIfNotEmpty(result, 'RPAD', getSystemNames(self.systemStatusDataRPAD()));
    addIfNotEmpty(result, 'RPRM', getSystemNames(self.systemStatusDataRPRM()));
    addIfNotEmpty(result, 'SKYPE', getSystemNames(self.systemStatusDataSKYPE()));
    addIfNotEmpty(result, 'VCS Control', getSystemNames(self.systemStatusDataVCSOnly()));
    addIfNotEmpty(result, 'VCS Expressway', getSystemNames(self.systemStatusDataVCSX()));
    addIfNotEmpty(result, 'ZOOM', getSystemNames(self.systemStatusDataZOOM()));

    return result;
};

DataRepository.prototype.getEndpointManagementMetadata = function () {
    return {
        filterConditions: [
            { title: 'Endpoint Name', name: 'name', type: 'string' },
            { title: 'Endpoint Tag', name: '_allTags', type: 'tag' },
            { title: 'Model', name: 'model', type: 'string' },
            { title: 'Firmware', name: 'firmware', type: 'string' },
            { title: 'Location', name: 'location', type: 'string' },
            { title: 'Host', name: 'host', type: 'string' },
            { title: 'Aliases', name: 'aliases', type: 'string' }
        ],
        searchgrid: {
            headers: ['Name', 'Aliases', 'Dir#', 'Model', 'Firmware', 'Host', 'Alt Name', 'Description', 'Price', 'Location', 'Custom Tags', 'System Tags', 'Edit'],
            rowProperties: ['name', 'aliases', 'dn', 'model', 'firmware', 'host', 'altName', 'description', 'price', 'location', 'customTagsFormatted', 'tmsTagsFormatted', 'edit'],
            searchableProperties: ['name', 'aliases', 'dn', 'model', 'firmware', 'host', 'altName', 'description', 'price', 'location', 'tags', 'tmsTags']
        }
    };
};

DataRepository.prototype.getEndpointsMetadata = function () {
    var endpointStatusColumns = [
        // The Name column is always shown
        { name: 'Name', widthRatio: 6, canBeToggled: false, type: 'string', propName: 'name' },
        { name: 'SIP', widthRatio: 3, canBeToggled: true, type: 'string', propName: 'sip' },
        { name: 'H323', widthRatio: 3, canBeToggled: true, type: 'string', propName: 'h323' },
        { name: 'E164', widthRatio: 3, canBeToggled: true, type: 'string', propName: 'e164' },
        { name: 'Dir#', widthRatio: 3, canBeToggled: true, type: 'string', propName: 'dn' },
        { name: 'Model', widthRatio: 4, canBeToggled: true, type: 'string', propName: 'model' },
        { name: 'Firmware', widthRatio: 3, canBeToggled: true, type: 'string', propName: 'firmware' },
        { name: 'Status', widthRatio: 3, canBeToggled: true, type: 'string', propName: 'status' },
        { name: 'H/W', widthRatio: 2, canBeToggled: true, type: 'string', propName: 'hwstatus' },
        { name: 'Host', widthRatio: 3, canBeToggled: true, type: 'string', propName: 'host' },
        { name: 'Num Calls', widthRatio: 3, canBeToggled: true, type: 'numeric', propName: 'numcalls' },
        { name: 'Quality', widthRatio: 3, canBeToggled: true, type: 'string', propName: 'qualityIndicator' },
        { name: 'Custom Tags', widthRatio: 6, canBeToggled: true, type: 'string', propName: 'tags' },
        { name: 'System Tags', widthRatio: 6, canBeToggled: true, type: 'string', propName: 'tmsTag' }
    ];

    var columnDictionary = {};
    _.forEach(endpointStatusColumns, function (col) {
        columnDictionary[col.name] = col;
    });

    var headers = _.map(endpointStatusColumns, 'name');
    var propNames = _.map(endpointStatusColumns, 'propName');
    var metadata = {
        endpointStatusColumnChoices: _.tail(headers),
        endpointStatusColumnDictionary: columnDictionary,
        filterConditions: [
            { title: 'Endpoint Name', name: 'name', type: 'string' },
            { title: 'Endpoint Tag', name: '_allTags', type: 'tag' },
            { title: 'Model', name: 'model', type: 'string' },
            { title: 'Firmware', name: 'firmware', type: 'string' },
            { title: 'Location', name: 'location', type: 'string' },
            { title: 'Host', name: 'host', type: 'string' },
            { title: 'SIP', name: 'sip', type: 'string' },
            { title: 'H323', name: 'h323', type: 'string' },
            { title: 'E164', name: 'e164', type: 'string' },
            { title: 'Dir#', name: 'dn', type: 'string' },
            { title: 'Number of Calls', name: 'numcalls', type: 'numeric' },
            { title: 'Quality', name: 'qualityString', type: 'string' }
        ],
        options: {
            headers: ['Name'],
            innerheaders: ['Dial String', 'Call Type', 'Packet Loss (%)', 'Jitter (ms)', 'Quality']
        },
        searchgrid: {
            headers: headers,
            innerheaders: ['Display Name', 'Dial String', 'Call Type', 'Call Rate', 'Presentation', 'Start Time', 'Duration', 'Packet Loss (%)', 'Jitter (ms)', 'Quality'],
            numericKeys: _.chain(endpointStatusColumns).filter({ type: 'numeric' }).map('propName').value(),
            rowProperties: propNames,
            sortableProperties: propNames
        },
        statusFilterMap: {
            'INCALL': 'IN CALL',
            'NONE': 'NOT CONFIGURED',
            'NOTAVAILABLE': 'NOT AVAILABLE'
        },
        statusOptions: ['AVAILABLE', 'NOT AVAILABLE', 'NOT CONFIGURED', 'IN CALL']
    };

    return metadata;
};

DataRepository.prototype.getHwStatusSummary = function (endpoints) {
    var result = { availableEndpointsWithDisconnectedCamera: 0, availableEndpointsWithDisconnectedDisplay: 0 };

    if (!_.isEmpty(endpoints)) {
        endpoints.forEach(function (endpoint) {
            if ((endpoint.status === 'Available') || (endpoint.status === 'InCall')) {
                if (endpoint.AVS && (endpoint.AVS.length > 0)) {
                    var AVS = endpoint.AVS;
                    var displays = AVS[0].Displays;
                    var sources = AVS[0].Sources;

                    if (_.isEmpty(displays)) {
                        result.availableEndpointsWithDisconnectedDisplay++;

                    } else {
                        // count all items with Connectec[0].text value of 'True'
                        var dispcount = _.filter(displays, function (display) {
                            return _.get(display, 'Connected[0].text') === 'True';
                        }).length;
                        if (dispcount === 0) {
                            result.availableEndpointsWithDisconnectedDisplay++;
                        }
                    }

                    if (_.isEmpty(sources)) {
                        result.availableEndpointsWithDisconnectedCamera++;

                    } else {
                        // count items that are connected and have a signal type of 'camera'
                        var camcount = _.filter(sources, function (source) {
                            return ((_.get(source, 'Connected[0].text') === 'True') &&
                                (_.get(source, 'SignalType[0].text', '').toLowerCase() === 'camera'));
                        }).length;

                        if (camcount === 0) {
                            result.availableEndpointsWithDisconnectedCamera++;
                        }
                    }
                }
            }
        });
    }

    return result;
};

DataRepository.prototype.getListOfEndpoints = function () {
    var self = this;
    var sourceList = self.endpointStatusData();
    return _.map(sourceList, 'name');
};

DataRepository.prototype.getListOfEndpointsWithIds = function () {
    var self = this;
    var sourceList = self.endpointStatusData();
    if (_.isEmpty(sourceList)) {
        return [];
    }
    return _.map(sourceList, function (item) {
        return { id: item.id, name: item.name, tags: item.tags, tmsTag: item.tmsTag };
    });
};

DataRepository.prototype.getListOfPexipLocations = function () {
    var self = this;
    var sourcelines = [];
    _.forOwn(self.systemStatusDataPexipLocations(), function (locations) {
        var location = locations[0];
        _.forEach(location, function (locItem) {
            sourcelines.push(locItem.Name);
        });
    });
    return sourcelines;
};

DataRepository.prototype.getRoomMetadata = function () {
    return {
        filterConditions: [
            { title: 'Room Name', name: 'name', type: 'string' },
            { title: 'Resource ID', name: 'extId', type: 'string' },
            { title: 'Endpoint' /*single endpoint assignment- for now*/, name: 'endpointNames', type: 'string' }
        ],
        searchgrid: {
            columnWidths: ['32%', '32%', '31%', '5%'],
            headers: ['Room Name', 'Resource ID', 'Endpoint' /*single endpoint assignment- for now*/, 'Edit'],
            rowProperties: ['name', 'extId', 'endpointNames', 'edit'],
            sortableProperties: ['name', 'extId', 'endpointNames']
        }
    };
};

DataRepository.prototype.getScheduledMeetingsMetadata = function () {
    return {
        innerTable: {
            innerheaders: ['id', 'Participant Name'],
            pageSize: 10,
            rowProperties: ['id', 'name'],
            toggleInnerCell: 'name',
            sortableCols: ['id' ,'name'],
            widths: ['0%', '100%']
        },
        numericKeys: ['conferenceID', 'duration'],
        searchGrid: [
            { key: 'startTime', header: 'Start Time', widthRatio: 1, sortable: true, switchable: true },
            { key: 'endTime', header: 'End Time', widthRatio: 1, sortable: true, switchable: true },
            { key: 'conferenceID', header: 'Conference ID', widthRatio: 1, sortable: true, switchable: true },
            {
                key: 'name',
                header: 'Meeting Name',
                widthRatio: 1.5,
                sortable: true,
                sortKey: '_nameText',
                switchable: true
            },
            { key: 'priority', header: 'Priority', widthRatio: 0.8, sortable: true, switchable: true },
            { key: 'assignedUser', header: 'Assigned User', widthRatio: 1, sortable: true, switchable: true },
            { key: 'duration', header: 'Duration', widthRatio: 1, sortable: true, switchable: true },
            { key: 'notes', header: 'Notes', widthRatio: 1, sortable: true, switchable: true },
            { key: 'edit', header: 'edit', widthRatio: 1, sortable: false, switchable: false }
        ],
        typeaheadConditions: [
            { title: 'Start Time', name: 'startTime', type: 'datetime' },
            { title: 'End Time', name: 'endTime', type: 'datetime' },
            { title: 'Duration', name: 'duration', type: 'numeric' },
            { title: 'Conference ID', name: 'conferenceID', type: 'string' },
            { title: 'Meeting name', name: '_nameText', type: 'string' },
            { title: 'Participants', name: '_participants', type: 'tag' },
            { title: 'Notes', name: 'notes', type: 'string' }
        ]
    };
};

//  TODO: refactor this in order to take advantage of SystemTypes.get<System>Array!!
DataRepository.prototype.hasBridges = function () {
    var self = this;
    if (self._hasBridges === null) {
        var dict = self.getDictionaryOfSystems();
        var systemTypes = Object.keys(dict);

        if (systemTypes.length > 0) {
            self._hasBridges =
                _.includes(systemTypes, 'ACANO') ||
                _.includes(systemTypes, 'CMS') ||
                _.includes(systemTypes, 'BJN') ||
                _.includes(systemTypes, 'CTPS - Conductor Managed') ||
                _.includes(systemTypes, 'CTPS - Standalone') ||
                _.includes(systemTypes, 'MCU') ||
                _.includes(systemTypes, 'PEXIP') ||
                _.includes(systemTypes, 'RMX') ||
                _.includes(systemTypes, 'SKYPE') ||
                _.includes(systemTypes, 'ZOOM');
        }
    }
    return self._hasBridges;
};

//  TODO: refactor this in order to take advantage of SystemTypes.get<System>Array!!
DataRepository.prototype.hasCallControlDevices = function () {
    var self = this;
    if (self._hasCallControlDevices === null) {
        var dict = self.getDictionaryOfSystems();
        var systemTypes = Object.keys(dict);

        if (systemTypes.length > 0) {
            self._hasCallControlDevices =
                _.includes(systemTypes, 'CUCM') ||
                _.includes(systemTypes, 'DMA') ||
                _.includes(systemTypes, 'VCS Control') ||
                _.includes(systemTypes, 'VCS Expressway') ||
                _.includes(systemTypes, 'VCS') ||
                _.includes(systemTypes, 'VCSX');
        }
    }
    return self._hasCallControlDevices;
};

DataRepository.prototype.hasEndpoints = function () {
    var self = this;
    if (self._hasEndpoints === null) {
        var listOfEndpoints = self.getListOfEndpoints();
        self._hasEndpoints = (listOfEndpoints.length > 0);
    }
    return self._hasEndpoints;
};

DataRepository.prototype.invokeServiceFailed = function (method, params, msg) {
    var self = this;
    if ($.inArray(method, ['GetQueryResultJson', 'GetQueryResultDatasetJson', 'GetAlertsJSON', 'GetOrgPreferences']) >= 0) {
        console.log('failed query; msg: ' + msg + ' query: ' + params.queryId);
        self.processWebServiceResult(method, params, null, msg);
    }
};

DataRepository.prototype.processWebServiceResult = function (method, params, retObj, errMsg) {
    var self = this;

    var methodsWithPossibleEmptyData = [
        'GetAlertsJSON',
        'GetFlexQueryResultJson',
        'GetKPIQueryResultDatasetJson',
        'GetOrgPreferences',
        'GetQueryResultDatasetJson',
        'GetQueryResultJson',
        'ListExportRegistrations',
        'GetRooms'
    ];

    if (_.isEmpty(retObj) && ($.inArray(method, methodsWithPossibleEmptyData) < 0)) {
        return;
    }

    switch (method) {
        case 'GetAlertsJSON':
            self.alertsData(retObj || {});
            break;

        case 'GetEndpointHistoricalInfo':
            if (retObj) {
                self.endpointHistoricalInfo(retObj);
            }
            break;

        case 'GetEndpointModels':
            self.endpointModels(retObj);
            break;

        case 'GetEndpointStatusXml':
            //demo data from database
            if (!retObj.Endpoint) {
                if (retObj.xmlPlayLoad && (retObj.xmlPlayLoad.length > 0)) {
                    retObj.Endpoint = retObj.xmlPlayLoad[0].Endpoint;
                }
            }
            if (retObj.Endpoint) {
                extractCallData(self, retObj.Endpoint);
                self.endpointStatusData(retObj.Endpoint);
                self.listOfEndpointsObservable(self.getListOfEndpoints());
                self.listOfEndpointsWithIdsObservable(self.getListOfEndpointsWithIds());
                self.endpointHwStatusSummary(self.getHwStatusSummary(retObj.Endpoint));
            }
            break;
        case 'GetEndpointsJson':
            if (retObj.data && retObj.data.endpoints) {

                let notDeletedEndpoints = _.filter(retObj.data.endpoints, ['deleted',false]);
                self.listOfEndpointsObservable(_.map(notDeletedEndpoints, 'name'));
                self.listOfEndpointsWithIdsObservable(_.map(notDeletedEndpoints, function (item) {
                    return { id: item.id, name: item.name,
                        tags: item.tags ? item.tags.join(',') : '', tmsTag: item.tmsTags ? item.tmsTags.join(',') : ''
                    };
                }));
                // this is used by Settings -> Endpoints
                self.endpointStatusData(_.map(notDeletedEndpoints, function (item) {
                    return {
                        id: item.id,
                        name: item.name,
                        aliases: item.aliases,
                        dn: item.dn,
                        model: item.model,
                        firmware: item.firmware,
                        description: item.description,
                        tags: item.tags ? item.tags.join(',') : '',
                        tmsTag: item.tmsTags ? item.tmsTags.join(',') : '',
                        host: item.hostAddress,
                        cucmDeviceName: item.cucmDeviceName,
                        serialNumber: item.serialNumber,
                        location: item.location,
                        price: item.price,
                        altName: item.altName,
                        dp: item.dp,
                        solarwindsLink: item.solarwindsLink,
                        directNumber: item.directNumber,
                        manufacturer: item.manufacturer,
                        sipAddress: item.sipAddress,
                        subCategory: item.subCategory,
                        building_city: item.building_city,
                        building_country: item.building_country,
                        building_key: item.building_key,
                        building_name: item.building_name,
                        building_region: item.building_region,
                        building_site: item.building_site,
                        building_state: item.building_state,
                        room_endpoint_type: item.room_endpoint_type,
                        room_floor: item.room_floor,
                        room_id: item.room_id,
                        room_name: item.room_name,
                        room_type: item.room_type
                    };
                }));
            }
            break;

        case 'GetSystemsJson':
            if (retObj.data && retObj.data.systems) {

                let notDeletedSystems = _.filter(retObj.data.systems, ['deleted',false]);
                //extractSystemStatuses

                let typeDictionary = [];
                let bridges = [];
                let callControls = [];
                let otherSystems = [];
                let allSystems = [];

                if (!_.isEmpty(notDeletedSystems)) {
                    notDeletedSystems.forEach(function (item) {
                        var type = _.toUpper(item.type);
                        if (!typeDictionary[type]) {
                            typeDictionary[type] = [];
                        }
                        typeDictionary[type].push(item);
                        //todo systemStatusDataPexipLocations
                    });
                }

                ['ACANO', 'CMS', 'BJN', 'CTPS', 'CISCOWEBEX', 'MCU', 'PEXIP', 'RMX', 'SKYPE', 'ZOOM', 'CUCM', 'DMA', 'VCS', 'VCSX', 'RPAD', 'RPRM'].forEach(function (type) {
                    addIfNotEmpty(allSystems, type, typeDictionary[type]);
                });

                ['ACANO', 'CMS', 'BJN', 'CTPS', 'CISCOWEBEX', 'MCU', 'PEXIP', 'RMX', 'SKYPE', 'ZOOM'].forEach(function (type) {
                    addIfNotEmpty(bridges, type, typeDictionary[type]);
                });

                ['CUCM', 'DMA', 'SKYPE', 'VCS', 'VCSX'].forEach(function (type) {
                    addIfNotEmpty(callControls, type, typeDictionary[type]);
                });

                ['RPAD', 'RPRM'].forEach(function (type) {
                    addIfNotEmpty(otherSystems, type, typeDictionary[type]);
                });

                self.dictionaryOfBridgesWithIdsObservable(bridges);
                self.dictionaryOfCallControlsWithIdsObservable(callControls);
                self.dictionaryOfNonBridgesNonCallControlsWithIdsObservable(otherSystems);
                self.dictionaryOfSystemsObservable(allSystems);
                // todo
                // self.listOfPexipLocationsObservable(allSystems);
            }
            break;

        case 'GetFiltersForFactKey':
            self.setDictionaryValue(self.FactFilterDictionary, method, params, retObj || [], errMsg);
            break;

        case 'GetFlexQueryMetaData':
            if (retObj && (_.isEmpty(self.flexQueryMetaData()))) {
                self.flexQueryMetaData(retObj);
            }
            break;

        case 'GetFlexQueryResultJson':
        case 'GetKPIQueryResultDatasetJson':
            self.setDictionaryValue(self.FlexQueryResultDictionary, method, params, retObj || [], errMsg);
            break;

        case 'GetLogiReportParams':
            if (retObj) {
                self.setDictionaryValue(self.logiReportParamsObservableDictionary, method, params, retObj);
            }
            break;

        case 'GetOrgPreferences':
            self.orgPreferences(retObj || {});
            break;

        case 'GetQueryResultDatasetJson':
            self.setDictionaryValue(self.QueryResultDatasetDictionary, method, params, retObj || [], errMsg);
            break;

        case 'GetQueryResultJson':
            retObj = retObj || {};
            if (params.queryId === 'FlexAccessQuery') {
                self.setDictionaryValue(self.FlexQueryResultDictionary, method, params, retObj, errMsg);

            } else if (params.queryId === 'HistoricalMetadataXml') {
                self.historicalMetadataXml(retObj);

            } else if (params.queryId === 'FlexAccessMetadata') {
                self.xmlMetadata(retObj);

            } else {
                self.setDictionaryValue(self.QueryResultDictionary, method, params, retObj, errMsg);
            }
            break;

        case 'GetRooms':
            self.rooms(retObj);
            break;

        case 'GetSummaryXml':
            if (retObj.Row) {
                pushToMaxObservable(self.summaryData, _.get(retObj, 'Row[0]'), 33);
            }
            break;

        case 'GetSystemDetailsByTypeXml':
            if (retObj) {
                if (params.typelist.indexOf('MCU') >= 0) {
                    extractVMRData(self, retObj);
                }
                if (params.typelist.indexOf('VCS') >= 0) {
                    extractCallControlData(self, retObj);
                }
            }
            break;

        case 'GetSystemDetailsXml':
            if (retObj) {
                mapSystemDetails(self, _.get(retObj, 'SystemDetail', retObj), params.systemId);
            }
            break;

        case 'GetSystemsList':
            var systems = self.systemsDictionary();
            systems[params.page] = retObj;
            self.systemsDictionary(systems);
            break;

        case 'GetSystemStatusXml':
            if (retObj.System) {
                extractSystemStatuses(self, retObj.System);
            }
            break;

        case 'GetSystemTrendXml':
            if (retObj.Point) {
                if (params.range > 0) {
                    params.range = 0;
                    self.systemTrendDataInitial(retObj.Point);
                    createSystemTrendDictionary(self);

                } else {
                    self.systemTrendDataIncremental(retObj.Point);
                    shiftSystemTrendDataValues(self);
                }
            }
            break;

        case 'GetTmsScheduleData':
            self.tmsScheduleData(retObj);
            break;

        case 'GetUsersList':
            self.usersList(retObj);
            break;

        case "ListExportRegistrations":
            self.exportRegistrations(retObj || {});
            break;

        default:
            break;
    }
};

DataRepository.getInstance = function () {
    if (instance === null) {
        instance = new DataRepository();
    }
    return instance;
};

export default DataRepository;
